import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IVehicle } from '../interfaces/task-info';

@Injectable({ providedIn: 'root' })
export class VehicleService {
  constructor(public http: HttpClient) {}

  public GetByRegNum(regNum: string): Promise<IVehicle> {
    return this.http.get<IVehicle>('api/vehicle/searchByRegNum?regNum=' + regNum).toPromise();
  }

  public GetByVin(vin: string): Promise<IVehicle> {
    return this.http.get<IVehicle>('api/vehicle/searchByVin?vin=' + vin).toPromise();
  }

  public GetFuelTypes(): Promise<string[]> {
    return this.http.get<string[]>('api/vehicle/fuel-types').toPromise();
  }

  public PatchVehicle(id: number, dto): Promise<void> {
    return this.http.patch<void>(`api/vehicle/${id}`, dto).toPromise();
  }
}
